export default {
  init() {

  },
  finalize() {
    // add 'events' to breadcrumb, can this be done beter via PHP/hooks?
    const eventsPerma = $('#single-bc-events').data('events-perma');
    const $eventsItem = $(`<a href="${eventsPerma}">Events</a>`);
    $('.global-breadcrumbs #breadcrumbs').find('a').after($eventsItem);
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/single-event.js